import navItemMixin from 'vue/mixins/nav-item';


export default {
    mixins: [navItemMixin],
    props: {
        facet: {
            type: String,
            default: 'base',
        },
        showSubNav: {
            type: Boolean,
            default: true,
        },
        child: Object,
        idx: Number,
        level: Number,
    },
    computed: {
        isShown() {
            return this.showSubNav && this.hasContent && (this.navigation[this.level].idx === this.idx);
        },
        hasChildren() {
            return Array.isArray(this.child.children) && !!this.child.children.length;
        },
        hasContent() {
            return this.hasFlyout || this.hasChildren;
        },
    },
    methods: {
        onMenuItemClick(e) {
            e.preventDefault();
            e.stopPropagation();

            if (!this.showSubNav || this.isShown || !this.hasContent) {
                this.$router.push(this.child.path);
                this.resetNavigation();
            } else {
                this.updateNav(true);
            }
        },
    },
};



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/vue/mixins/interactive-nav-item/index.js